
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Capacitor } from '@capacitor/core';


// Only load PWA elements when in a native environment or needed
if (Capacitor.isNativePlatform()) {
  defineCustomElements(window);
}

// Mount the React application
createRoot(document.getElementById("root")!).render(<App />);
